import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css']
})
export class DeleteUserComponent implements OnInit {

  data: any;
  modelSubtitle = false
  users:any = []
  i: any;
  deleteId: any = "";

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  searchUser = ""


  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllUsers(this.pageNumber,this.recordsPerPage)
  } 

  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }



  // getAllUsers(){
  //   this.generic_service.getUsers().subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.Users = response.response
  //     }
  //   )
  // }

  onTableDataChange(event: any) {
    this.pageNumber = event - 1;
    this.pageNumber1 = event;

    if(this.searchUser != ""){
      this.searchCustomer(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllUsers(this.pageNumber,this.recordsPerPage);
    }
  }

  getAllUsers(pageNumber:any,recordsPerPage:any){
    this.generic_service.getAllUsers(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response);
        let arr = []
        for(var i=0; i<response.response.userList.length; i++){
          if(response.response.userList[i].userType.toLowerCase() != 'su'){
            arr.push(response.response.userList[i])
          }
        }
        this.users = arr;
        this.totalRecords = response.response.totalRecords

        console.log(this.users)
      }
    )
  }
 
  deleteUser(){
    this.generic_service.deleteUser(this.deleteId).subscribe(
      (res:any)=>{
        console.log(res)
        this.toastr.success("Successfully Deleted");
        this.getAllUsers(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  searchCustomer(pageNumber: any,recordsPerPage: any){
    if(this.searchUser != ""){
      this.generic_service.searchCustomer(this.searchUser,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          let arr = []
          for(var i=0; i<response.response.userList.length; i++){
            if(response.response.userList[i].userType.toLowerCase() != 'su'){
              arr.push(response.response.userList[i])
            }
          }
          this.users = arr;
          this.totalRecords = response.response.totalRecords
  
          console.log(this.users)
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllUsers(this.pageNumber,this.recordsPerPage)
    }

  }

}
